import { Warehouse } from "lucide-react";
import { cn } from "@/lib/utils";
import { useWarehouse, WAREHOUSE_TABS } from "@/contexts/WarehouseContext";

export function WarehouseSwitch() {
  const { warehouse, setWarehouse } = useWarehouse();
  return (
    <div role="tablist" aria-label="Opslaglocatie" data-testid="warehouse-switch"
      className="grid grid-cols-2 gap-2 px-4 md:px-8 py-2 border-t border-border bg-card">
      {WAREHOUSE_TABS.map((t) => {
        const active = warehouse === t.id;
        return (
          <button key={t.id} type="button" role="tab" aria-selected={active}
            data-testid={`warehouse-tab-${t.id}`} onClick={() => setWarehouse(t.id)}
            className={cn(
              "touch-tap flex items-center justify-center gap-2 rounded-md border px-3 py-2 text-left",
              "transition-colors duration-200 min-h-[44px] md:min-h-[48px]",
              active
                ? "bg-primary text-primary-foreground border-primary shadow-sm"
                : "bg-background text-foreground border-border hover:border-primary/50",
            )}>
            <Warehouse className="w-5 h-5 shrink-0" />
            <span className="leading-tight">
              <span className="block text-[11px] uppercase tracking-wider opacity-80">Magazijn {t.number}</span>
              <span className="block text-sm md:text-base font-semibold">
                <span className="md:hidden">{t.short}</span>
                <span className="hidden md:inline">{t.label}</span>
              </span>
            </span>
          </button>
        );
      })}
    </div>
  );
}
